import script from "./template5.vue?vue&type=script&setup=true&lang=js"
export * from "./template5.vue?vue&type=script&setup=true&lang=js"

import "./template5.vue?vue&type=style&index=0&id=593de7b7&lang=less"

const __exports__ = script;

export default __exports__